import { FC, useMemo } from 'react'
import { Table } from 'antd'
import PageLayout from '../../components/page-layout/page-layout'
import TableWrapper from '../../components/table-wrapper/table-wrapper'
import { useGetMyRibbonsQuery } from '../../store/api/ribbons-api'
import useEndpointQueryParams, {
    DeserializeFilters,
} from '../../hooks/table-pages/use-endpoint-query-parameters'
import useTablePagination from '../../hooks/table-pages/use-table-pagination'
import { getRibbonsColumns } from './constants/columns'
import { defaultParams } from './constants/default-params'
import CreateRibbon from './components/create-ribbon/create-ribbon'
import RibbonRollsCalculator from './components/ribbon-rolls-calculator/ribbon-rolls-calculator'

const deserializeFilters: DeserializeFilters = () => ({})

const RibbonsPage: FC = () => {
    const params = useEndpointQueryParams({ deserializeFilters })

    const queryArg = useMemo(
        () => ({
            ...defaultParams,
            ...params,
        }),
        [params]
    )

    const { data, isFetching, refetch } = useGetMyRibbonsQuery(queryArg, {
        refetchOnMountOrArgChange: true,
    })

    const pagination = useTablePagination(queryArg, data)
    const ribbons = data?.data || []

    const columns = useMemo(() => getRibbonsColumns(() => refetch()), [refetch])

    return (
        <PageLayout title='Риббоны' beforeUser={<CreateRibbon onSuccess={() => refetch()} />}>
            <RibbonRollsCalculator />
            <TableWrapper>
                <Table
                    rowKey={record => record.documentId}
                    columns={columns}
                    dataSource={ribbons}
                    loading={isFetching}
                    pagination={pagination}
                    scroll={{ x: 'max-content' }}
                />
            </TableWrapper>
        </PageLayout>
    )
}

export default RibbonsPage
